import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-14 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 text-foreground-900 mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                <i className="ri-play-circle-line"></i>
              </span>
              <span className="font-heading text-lg font-bold">猫咪视频大全</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              汇聚全网最热门、最治愈的猫咪视频，涵盖搞笑猫咪视频、可爱猫咪日常、萌猫短片等精选内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">关于我们</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">热门推荐</Link></li>
              <li><Link to="/category/catknowledge" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200">养猫攻略</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>hello@catvideo.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-wechat-line text-foreground-400"></i>
                <span>CatVideo2024</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-map-pin-line text-foreground-400"></i>
                <span>浙江省杭州市</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-background-200">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 猫咪视频大全. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}